import { IconClose, IconShield } from "@veto/ui";

export function InAppBanner({
  title,
  body,
  onOpen,
  onDismiss,
}: {
  title: string;
  body: string;
  onOpen: () => void;
  onDismiss: () => void;
}) {
  return (
    <div
      className="inapp-banner"
      role="status"
      aria-live="polite"
      title="In-app preview while unlocked. OS notifications stay wake-only unless you enable previews."
    >
      <div className="inapp-banner-icon" aria-hidden>
        <IconShield size={22} />
      </div>
      <button type="button" className="inapp-banner-main" onClick={onOpen}>
        <strong>{title}</strong>
        <span>{body}</span>
      </button>
      <button
        type="button"
        className="inapp-banner-close"
        aria-label="Dismiss"
        title="Dismiss"
        onClick={onDismiss}
      >
        <IconClose size={16} />
      </button>
    </div>
  );
}
